module.exports = __webpack_public_path__ + "static/img/writer.53ea1eb6.png";